import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FileArchive, PenLine } from "lucide-react";
import type { ReactNode } from "react";

/** Shared add-skill items — used by the rail head's create glyph, the My
 *  Skills section's right-click menu, and its "New skill" closing row. */
export const addSkillMenuItems = (
  createFromScratch: () => void,
  openUploadZipDialog: () => void,
) => (
  <>
    <DropdownMenuItem onClick={createFromScratch}>
      <PenLine />
      Create from scratch
    </DropdownMenuItem>
    <DropdownMenuItem onSelect={openUploadZipDialog}>
      <FileArchive />
      Upload a skill
    </DropdownMenuItem>
  </>
);

/**
 * The create-or-upload choice, hung from whatever trigger the caller passes
 * as `children` (rendered `asChild`, so it must forward its ref). Actions
 * come from the caller (`useSkillsRailAddActions`) so the same instance
 * backs this menu and the section's right-click menu, and a single
 * upload dialog is rendered by the caller.
 */
export function SkillsRailAddSkillMenu({
  createFromScratch,
  openUploadZipDialog,
  alignOffset,
  children,
}: {
  createFromScratch: () => void;
  openUploadZipDialog: () => void;
  /** Shifts the menu's leading edge right of the trigger's — a full-width
   *  row trigger wants the menu under its label, not its far-left edge. */
  alignOffset?: number;
  children: ReactNode;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent align="start" alignOffset={alignOffset}>
        {addSkillMenuItems(createFromScratch, openUploadZipDialog)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
